import React, { useCallback, useMemo } from 'react';

import {fonts} from "../../../constants/utils"

import './fontArray.scss';

interface IFontArray {
  onFontChanged: (font:string)=>void
}

export const FontArray = (props:IFontArray)=>{
  const{onFontChanged} = props

  const handleFont = useCallback(
    e => {
      e.preventDefault();

      onFontChanged(e.target.name);
    },
    [],
  )

  const renderFontsBtn = useMemo(
    () =>
      fonts.map(item => (
        <button
          key={item.value}
          className="leftWorkFontsFontBtn"
          name={item.value}
          style={{fontFamily: item.value}}
          onClick={handleFont}
        >
          {item.value}
        </button>
      )),
    [handleFont],
  )

  return <div className="leftWorkFontsFontBtn_cont">{renderFontsBtn}</div>
}